import React, { useReducer } from "react";
import AlertContext from "../contexts/AlertContext";
import PropTypes from "prop-types";

const initialState = {
  alerts: []
};

const AlertContextProvider = ({ children }) => {
  const getAlertId = () =>
    `_${Math.random()
      .toString(36)
      .substr(2, 9)}`;

  const reducer = (state, action) => {
    switch (action.type) {
      case "addAlert":
        return { ...state, alerts: [...state.alerts, { ...action.alert, id: getAlertId() }] };
      case "removeAlert":
        return { ...state, alerts: state.alerts.filter(a => a.id !== action.id) };
      default:
        return initialState;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return <AlertContext.Provider value={{ state, dispatch }}>{children}</AlertContext.Provider>;
};

AlertContextProvider.propTypes = {
  children: PropTypes.object.isRequired
};

export default AlertContextProvider;
